<template>
  <div class="course-feedback">
    <RocketIcon class="course-feedback__icon" />
    <div class="course-feedback__links">
      <span @click="toggleModal" class="course-feedback__link">
        {{
          rating && rating.confirmed ? 'Review your rating' : 'Rate this course'
        }}
      </span>
    </div>
    <FeedbackModal v-if="modalOpened" @close-modal="toggleModal" />
  </div>
</template>

<script>
import { mapState } from 'vuex'
import FeedbackModal from '@/components/modals/FeedbackModal.vue'
import RocketIcon from '@/assets/icons/beta/rocket.svg'

export default {
  name: 'CourseFeedback',
  components: {
    RocketIcon: { ...RocketIcon, name: 'RocketIcon' },
    FeedbackModal,
  },
  computed: {
    ...mapState({
      rating: state => state.courses.courseRating,
      modalOpened: state => state.courses.courseRatingModalOpened,
    }),
  },
  methods: {
    toggleModal() {
      this.$store.dispatch('courses/toggleRatingModal', !this.modalOpened)
    },
  },
}
</script>

<style lang="scss" scoped>
.course-feedback {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  color: var(--white);
  background: rgba(255, 255, 255, 0.1);
  padding: 5px;
  border-radius: 100px;
  @include mobile {
    padding: 10px 15px;
  }
  @include lg-desktop {
    margin: 0;
  }
  &__icon {
    fill: var(--white);
    margin: 0 5px;
    @include mobile {
      margin: 0 10px;
    }
  }
  &__title,
  &__link {
    padding: 0;
    line-height: 0;
    font-size: 14px;
    text-transform: uppercase;
  }
  &__title {
    text-transform: uppercase;
    font-family: var(--font-bold);
    margin: 0;
  }
  &__links {
    margin: 0 10px 0 10px;
  }
  &__link {
    cursor: pointer;
    transition: 0.3s all ease;
    margin: 0 5px;
    color: var(--white);
    &:hover {
      color: var(--orange);
    }
    &:visited {
      color: var(--blue);
    }
  }
}
</style>
